import { useNavigableContext } from './context'
import { type Item, type NavigableItemApi } from './types'

export function useNavigableItem<IDENTIFIER>(item: Item<IDENTIFIER>): NavigableItemApi<IDENTIFIER> {
  const register = useNavigableContext()
  return register(item)
}
